import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import * as Sentry from '@sentry/react'
import './index.css'
import App from './App.tsx'
import { etoUstarevshiyKusok, idetPerezagruzka, naOtkazKuska } from './shared/ustarevshiyKusok'

const dsn = import.meta.env.VITE_SENTRY_DSN as string | undefined
if (dsn) {
  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    release: (import.meta.env.VITE_SENTRY_RELEASE as string | undefined) || undefined,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 0.1,
    sendDefaultPii: false,
    // s723: страница уходит на перезагрузку после выката — её последние ошибки не событие.
    beforeSend: (event) => (idetPerezagruzka() ? null : event),
  })
}

/*
 * ⛔ s523 — КУСОК СБОРКИ, ПРОПАВШИЙ ПОСЛЕ ВЫКАТА, ЛОВИТСЯ ДО РЕНДЕРА.
 *
 * Vite объявляет об этом своим событием, и если его никто не отменяет,
 * обещание отклоняется и дерево падает. Слушатель ставится ДО createRoot:
 * отказ предзагрузки случается раньше, чем что-либо успевает отрисоваться.
 * Граница над маршрутами (UstarevshiyKusok в App.tsx) ловит второй путь —
 * отказ самого ленивого импорта во время перехода.
 */
window.addEventListener('vite:preloadError', naOtkazKuska)

window.addEventListener('unhandledrejection', (event) => {
  if (etoUstarevshiyKusok(event.reason)) {
    naOtkazKuska(event)
  }
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
